import { useState } from 'react';

function SubmittedQuestionsItem({
  question,
  handleToggleModal,
  handleChangeSelectedQuestion,
  handleSetQuestionToEditValues,
  handleSetQuestionToEditInputs,
  setSelectedQuestion,
}) {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggleExpand = () => {
    setIsExpanded((prev) => !prev);
  };

  const handleDelete = () => {
    handleChangeSelectedQuestion(question.id, question.updatedAt);
    handleToggleModal();
  };

  const correctAnswer = question.answer.filter((answer) => answer.correct)[0]
    ?.text;
  const incorrectAnswers = question.answer
    .filter((answer) => !answer.correct)
    .filter((answer) => answer.text);

  const handleEdit = () => {
    const incorrectAnswersValues = incorrectAnswers.reduce(
      (acc, answer, index) => {
        acc[`incorrectAnswer${index + 1}`] = answer.text;
        return acc;
      },
      {},
    );

    const incorrectAnswersInputs = incorrectAnswers.reduce(
      (acc, answer, index) => {
        acc[`incorrectAnswer${index + 1}`] = {
          name: `incorrectAnswer${index + 1}`,
          id: `incorrect-answer${index + 1}`,
          type: 'text',
          label: `Incorrect Answer${index === 0 ? '' : ` ${index + 1}`}`,
          placeholder: 'Example: Appendix C',
          hasAddButton: index === incorrectAnswers.length - 1,
        };
        return acc;
      },
      {},
    );

    const values = {
      text: question.text,
      ...incorrectAnswersValues,
      correctAnswer,
      answerLocation: question.answerLocation || '',
    };

    const validatedIncorrectAnswersInputs =
      Object.values(incorrectAnswersInputs).length > 0
        ? Object.values(incorrectAnswersInputs)
        : [
            {
              name: 'incorrectAnswer1',
              id: 'incorrect-answer1',
              type: 'text',
              label: 'Incorrect Answer',
              placeholder: 'Example: Appendix C',
              hasAddButton: true,
            },
          ];

    const inputs = [
      {
        name: 'text',
        id: 'text',
        type: 'text',
        label: 'Question*',
        placeholder: 'Example: Which appendix of the AFDP 3-85...',
      },
      {
        name: 'correctAnswer',
        id: 'correct-answer',
        type: 'text',
        label: 'Correct Answer*',
        placeholder: 'Example: Appendix A',
      },
      ...validatedIncorrectAnswersInputs,
      {
        name: 'answerLocation',
        id: 'answer-location',
        type: 'text',
        label: 'Where does the answer come from?',
        placeholder: 'Example: AFDP-3-85 (DEC 2023) / CHAPTER 01',
      },
    ];

    setSelectedQuestion(question);
    handleSetQuestionToEditValues(values);
    handleSetQuestionToEditInputs(inputs);
  };

  return (
    <article className="list__item">
      <div
        className={`list__item__question__container ${
          isExpanded ? 'list__item__question__container--expanded' : ''
        }`}
      >
        <span className="list__item__question">{question.text}</span>
        <button
          className="list__item__expand-button"
          data-test={`${question.text
            .replaceAll(' ', '-')
            .replace('?', '')
            .toLowerCase()}-list__item__expand-button`}
          onClick={handleToggleExpand}
        >
          {isExpanded ? (
            <i className="icon-expand select-icon rotate down" />
          ) : (
            <i className="icon-expand select-icon rotate" />
          )}
        </button>
      </div>
      {isExpanded ? (
        <div>
          <p>
            <span className="list__item__question">Correct answer: </span>
            {correctAnswer || ''}
          </p>
          {incorrectAnswers.length > 0 ? (
            <>
              <span className="list__item__question">Incorrect answers: </span>
              <ul>
                {incorrectAnswers.map((answer) => (
                  <li key={answer.id}>{answer.text}</li>
                ))}
              </ul>
            </>
          ) : null}
          {question.noteUser ? (
            <p>
              <span className="list__item__question">Notes: </span>
              {question.noteUser}
            </p>
          ) : null}
          <div className="list__item__buttons__container">
            <button
              data-test="edit-submitted-question-button"
              className="btn btn-primary btn-add"
              onClick={handleEdit}
            >
              Edit
            </button>
            <button
              onClick={handleDelete}
              className="list__item__delete-button btn btn-primary btn-add"
              data-test="delete-submitted-question-button"
            >
              Delete
            </button>
          </div>
        </div>
      ) : null}
    </article>
  );
}

export default SubmittedQuestionsItem;
